module.exports = __webpack_public_path__ + "img/triangle-left.d27e54e6.png";